module.exports = __webpack_public_path__ + "static/img/课程资源建设平台学生端 2.6e98b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/课程资源建设平台学生端 2.png
// module id = LO6u
// module chunks = 13